import Accordion from 'entities/Accordion'
import { PdfGenerator } from 'features/PdfGenerator'

export const TableDisplayAccordion = () => {
  return (
    <Accordion title='Table display'>
      <PdfGenerator />
    </Accordion>
  )
}
